import { render, staticRenderFns } from "./AttachmentThumbnail.vue?vue&type=template&id=f077787a"
import script from "./AttachmentThumbnail.vue?vue&type=script&lang=ts"
export * from "./AttachmentThumbnail.vue?vue&type=script&lang=ts"
import style0 from "./AttachmentThumbnail.vue?vue&type=style&index=0&id=f077787a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports